import { render, staticRenderFns } from "./DerivedDataBadge.vue?vue&type=template&id=508458fb&scoped=true"
import script from "./DerivedDataBadge.vue?vue&type=script&lang=js"
export * from "./DerivedDataBadge.vue?vue&type=script&lang=js"
import style0 from "./DerivedDataBadge.vue?vue&type=style&index=0&id=508458fb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508458fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508458fb')) {
      api.createRecord('508458fb', component.options)
    } else {
      api.reload('508458fb', component.options)
    }
    module.hot.accept("./DerivedDataBadge.vue?vue&type=template&id=508458fb&scoped=true", function () {
      api.rerender('508458fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/DerivedDataBadge.vue"
export default component.exports